module.exports = {
	"id": "PK",
	"name": "Pakistan",
	"month": "2016-10",
	"access_date": "2016-11-03",
	"data": {
		"chrome": {
			"4": null,
			"5": 0.002838,
			"6": null,
			"7": null,
			"8": 0.002838,
			"9": null,
			"10": 0.005676,
			"11": 0.017028,
			"12": 0.005676,
			"13": 0.008514,
			"14": 0.008514,
			"15": 0.005676,
			"16": 0.011352,
			"17": 0.01419,
			"18": 0.005676,
			"19": 0.011352,
			"20": 0.017028,
			"21": 0.011352,
			"22": 0.022704,
			"23": 0.039732,
			"24": 0.02838,
			"25": 0.059598,
			"26": 0.019866,
			"27": 0.025542,
			"28": 0.031218,
			"29": 0.034056,
			"30": 0.031218,
			"31": 0.102168,
			"32": 0.048246,
			"33": 0.096492,
			"34": 0.031218,
			"35": 0.017028,
			"36": 0.011352,
			"37": 0.008514,
			"38": 0.019866,
			"39": 0.034056,
			"40": 0.017028,
			"41": 0.011352,
			"42": 0.01419,
			"43": 0.280962,
			"44": 0.036894,
			"45": 0.031218,
			"46": 0.036894,
			"47": 0.05676,
			"48": 0.059598,
			"49": 1.29129,
			"50": 0.059598,
			"51": 0.280962,
			"52": 0.229878,
			"53": 11.675532,
			"54": 4.15767,
			"55": 0.263934,
			"56": 0.08514,
			"57": null
		},
		"firefox": {
			"2": null,
			"3": 0.102168,
			"4": 0.002838,
			"5": 0.002838,
			"6": null,
			"7": null,
			"8": 0.002838,
			"9": 0.002838,
			"10": 0.005676,
			"11": 0.005676,
			"12": 0.008514,
			"13": 0.002838,
			"14": 0.008514,
			"15": 0.008514,
			"16": 0.008514,
			"17": 0.005676,
			"18": 0.019866,
			"19": 0.005676,
			"20": 0.005676,
			"21": 0.002838,
			"22": 0.002838,
			"23": 0.008514,
			"24": 0.005676,
			"25": 0.005676,
			"26": 0.008514,
			"27": 0.008514,
			"28": 0.005676,
			"29": 0.019866,
			"30": 0.01419,
			"31": 0.011352,
			"32": 0.011352,
			"33": 0.019866,
			"34": 0.011352,
			"35": 0.019866,
			"36": 0.01419,
			"37": 0.01419,
			"38": 0.025542,
			"39": 0.019866,
			"40": 0.022704,
			"41": 0.022704,
			"42": 0.025542,
			"43": 0.12771,
			"44": 0.090816,
			"45": 0.053922,
			"46": 0.051084,
			"47": 0.275286,
			"48": 0.21285,
			"49": 1.890108,
			"50": 0.363264,
			"51": 0.002838,
			"52": null,
			"3.5": 0.005676,
			"3.6": 0.01419
		},
		"opera": {
			"9": null,
			"11": null,
			"12": null,
			"15": null,
			"16": null,
			"17": null,
			"18": 0.002838,
			"19": null,
			"20": null,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": null,
			"29": null,
			"30": 0.002838,
			"31": null,
			"32": null,
			"33": null,
			"34": 0.005676,
			"35": 0.005676,
			"36": 0.031218,
			"37": 0.079464,
			"38": 0.019866,
			"39": 0.017028,
			"40": 0.505164,
			"41": 0.09933,
			"42": null,
			"43": null,
			"9.5-9.6": null,
			"10.0-10.1": 0.002838,
			"10.5": null,
			"10.6": null,
			"11.1": null,
			"11.5": null,
			"11.6": 0.005676,
			"12.1": 0.01419
		},
		"safari": {
			"0": null,
			"4": 0.002838,
			"5": null,
			"6": null,
			"7": 0.005676,
			"8": 0.019866,
			"9": 0.017028,
			"10": 0.068112,
			"3.1": null,
			"3.2": null,
			"5.1": 0.005676,
			"6.1": null,
			"7.1": 0.002838,
			"9.1": 0.048246
		},
		"ios_saf": {
			"8": 0,
			"10": 2.14441371857,
			"3.2": 0,
			"4.0-4.1": 0,
			"4.2-4.3": 0,
			"5.0-5.1": 0,
			"6.0-6.1": 0,
			"7.0-7.1": 0.0577894683597,
			"8.1-8.4": 0.106763594088,
			"9.0-9.2": 0.0509330907577,
			"9.3": 0.777056128226
		},
		"android": {
			"3": 0,
			"4": 0.110113436693,
			"53": null,
			"2.1": 0,
			"2.2": 0,
			"2.3": 0.0137641795866,
			"4.1": 0.397194896641,
			"4.2-4.3": 0.992987241602,
			"4.4": 2.27698856589,
			"4.4.3-4.4.4": 2.29665167959
		},
		"ie": {
			"6": 0.0298498804781,
			"7": 0.00596997609562,
			"8": 0.229844079681,
			"9": 0.0298498804781,
			"10": 0.0596997609562,
			"11": 0.394018422311,
			"5.5": null
		},
		"op_mob": {
			"0": 0.692956382626,
			"10": 0,
			"11": 0,
			"12": 0,
			"11.1": 0,
			"11.5": 0,
			"12.1": 0.0192487884063
		},
		"edge": {
			"12": 0.053922,
			"13": 0.087978,
			"14": 0.107844
		},
		"ie_mob": {
			"10": 0.175115943662,
			"11": 0.712972056338
		},
		"bb": {
			"7": 0.032229,
			"10": null
		},
		"samsung": {
			"0": 1.847796
		},
		"and_uc": {
			"0": 20.368728
		},
		"op_mini": {
			"0": 9.33608082897
		},
		"and_chr": {
			"0": 30.635172
		},
		"and_ff": {
			"0": 0.042972
		}
	},
	"total": 98.014081
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/caniuse-db/region-usage-json/PK.json
 ** module id = 622
 ** module chunks = 0
 **/